// This is to provide compatibility for some libs (in our case the just-handlebars-helpers)
// which rely on the `global` object, which is defined by webpack but not by vite
window.global ||= window

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { formKitPlugin, config } from '../utils/formkitPlugin'
import { createI18n } from 'vue-i18n'
import { VueQueryPlugin } from '@tanstack/vue-query'

import App from '../questionnaire/App.vue'
import router from '../questionnaire/questionnaireRouter'
import '../questionnaire/questionnaire.css'
import DocumentViewLayoutVue from '../layouts/DocumentViewLayout.vue'
import DashboardLayout from '../layouts/DashboardLayout.vue'
import QuestionnaireLayoutVue from '../layouts/QuestionnaireLayout.vue'
import { useLsGeneralStore } from '@/questionnaire/stores/application'
import * as Sentry from '@sentry/vue'
import clickOutsideDirective from '@/utils/clickOutsideDirective'

const app = createApp(App)

Sentry.init({
  app,
  dsn: 'https://9b52cbafd45347b3dd6ad57c916531d3@o4508636178612224.ingest.de.sentry.io/4508636363423824',
  integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
  // Only enable Sentry in production environment
  enabled: import.meta.env.PROD,
  // Tracing
  tracesSampleRate: import.meta.env.PROD ? 0.05 : 1.0,
  tracePropagationTargets: ['localhost', /^https:\/\/*.legal-standard\.de\//],
  // Session Replay
  replaysSessionSampleRate: import.meta.env.PROD ? 0.01 : 0.1,
  replaysOnErrorSampleRate: 1.0,
})

app.use(formKitPlugin, config)

const pinia = createPinia()
const i18n = createI18n({ locale: 'de', allowComposition: true, legacy: false })
app.directive('click-outside', clickOutsideDirective)
app.use(VueQueryPlugin)
app.use(pinia)
app.use(i18n)

const store = useLsGeneralStore()

store
  .loginFromToken()
  .then(() => {
    app.use(router)
    app.component('DocumentViewLayout', DocumentViewLayoutVue)
    app.component('QuestionnaireLayout', QuestionnaireLayoutVue)
    app.component('DashboardLayout', DashboardLayout)
    app.mount('#app')
  })
  .catch(error => {
    if (error.name === 'LoginFromTokenError') {
      console.info('No valid login token found, redirecting to login page')
      window.location.href = '/app/login'
    } else {
      console.error('Error during login:', error)
    }
  })
